import React from "react"
import { Navigate } from "react-router-dom"

// Helper function to check if the token is expired
const isTokenExpired = () => {
  const expirationTime = localStorage.getItem("auth_expiration")
  const currentTime = Date.now()

  return !expirationTime || currentTime > expirationTime
}

const AuthMiddleware = (props) => {
  // Check for token existence and expiration
  const isAuthenticated = localStorage.getItem("auth") && !isTokenExpired()
  const userRole = localStorage.getItem("role");
  if (!isAuthenticated) {
    localStorage.removeItem("role");
    localStorage.removeItem("auth")
    localStorage.removeItem("auth_expiration")
    return (
      <Navigate to={{ pathname: "/login", state: { from: props.location } }} />
    )
  }

  

  return <React.Fragment>{props.children}</React.Fragment>
}

export default AuthMiddleware
